import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  Stack,
  VStack,
  HStack,
  Text,
  Tag,
  TagLabel,
  Button,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
  // useDisclosure,
} from "@chakra-ui/react";

import { CopyIcon } from "@chakra-ui/icons";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import InfoOutlined from "@material-ui/icons/InfoOutlined";

import { ReactComponent as ReferralIllustration } from "assets/svg/referral-illustration.svg";
import { useMemo } from "react";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import { ReactComponent as FacebookReferIcon } from "assets/svg/facebook-refer.svg";
import { ReactComponent as TwitterReferIcon } from "assets/svg/twitter-refer.svg";
import { ReactComponent as WhatsappReferIcon } from "assets/svg/whatsapp-refer.svg";
import { ReactComponent as CopyReferIcon } from "assets/svg/copy-refer.svg";

// import User from "assets/profile.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
// import Support from "assets/svg/icons-new/support.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
// import VerificationIcon from "../../../assets/svg/verification.svg";

//assets

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import ReferrerList from "components/ReferrerList/ReferrerList";
import { CustomTab } from "../Cards/MyCard";

import { useHistory } from "react-router-dom";

// import AccountLink from "components/AccountLink/AccountLink";
//   import VerificationCard from "components/VerificationCard/VerificationCard";

// import { useIntercom } from "react-use-intercom";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";
// import ClaimRewardsModal from "components/Modals/refer/ClaimReward";

import {
  useGetReferralsQuery,
  useGetReferralTradesQuery,
} from "services/arbitraryApi";

// const isEmptyString = (val) => val === "" || val === undefined || val === null;
import useCopy from "hooks/useCopy";
import { isProd, isDev } from "config/constant";

const AccountReferral = (props) => {
  // const { boot } = useIntercom();
  const userData = props.userData;
  console.log("USER DATA", userData);

  const appHost = useMemo(() => {
    if (isProd) return "https://dashboard.bitmama.io";
    if (isDev) return "https://bitmama-staging.web.app";
  }, []);

  const { onCopy, value } = useCopy(userData?.refCode);
  const { onCopy: onLinkCopy, value: linkValue } = useCopy(
    `${appHost}/signup?refCode=${userData?.refCode}`
  );

  const history = useHistory();

  // const { isOpen, onOpen, onClose } = useDisclosure();
  // const [hasRewards, setHasRewards] = useState(true);

  const { data, isLoading } = useGetReferralsQuery(userData?.userId);
  const { data: refTrades, isLoading: isRefTradesLoading } =
    useGetReferralTradesQuery(userData?.userId);

  // console.log("REFERRAL TRADES", refTrades);

  const referredUsers = useMemo(
    () => (data?.referrals ?? []).map((r) => ({ ...r?.referredUserId })),
    [data]
  );

  const referredTrades = useMemo(
    () => (refTrades?.earnings ?? []).map((r) => ({ ...r?.referredUserId })),
    [refTrades]
  );

  console.log("REFERRAL TRADES", referredTrades);

  // const handleClose = () => {
  //   setHasRewards(false);
  //   onClose();
  // };

  // useEffect(() => {
  //   if (hasRewards) {
  //     onOpen();
  //   }
  // }, [hasRewards, onOpen]);

  // console.log("ACCOUNT VERIFICAATION PAGE PROPS", props);

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <div className="account-container">
          <Flex className="flex">
            <Box flex=".8" borderRight="1px solid #D9DBE9" position="sticky">
              <Container maxW="calc(100% - 2em)" ml="10px">
                <Stack mb="48px">
                  <Heading>Account</Heading>
                  <Breadcrumb
                    className="animate__animated animate__fadeInDown"
                    separator={
                      <ArrowForwardIosRoundedIcon
                        style={{ fontSize: ".8em", color: "#6E7191" }}
                      />
                    }
                  >
                    <BreadcrumbItem>
                      <BreadcrumbLink to="/dashboard/account">
                        Account
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage to="">
                        Refer a friend
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Stack>

                <AccountSidebar
                  current="refer"
                  userData={userData}
                  logout={props.logout}
                />
              </Container>
            </Box>

            <Box flex="1">
              <Container
                maxW="lg"
                // ml={{ lg: "60px" }}
              >
                <Stack gridGap="20px" padding={"1rem"}>
                  <VStack>
                    <VStack>
                      <Text
                        fontSize="18px"
                        color="#14142B"
                        fontWeight="600"
                        mb="20px !important"
                      >
                        Refer a friend
                      </Text>
                      <Box as={ReferralIllustration} />

                      <Text
                        color="var(--primary)"
                        fontWeight="600"
                        fontSize="18px"
                        mt="4px !important"
                      >
                        Get 20% on P2P Commission fees
                      </Text>
                      <Text fontSize="sm" mt="4px !important">
                        When all referred users completes a trade.{" "}
                      </Text>
                      <HStack mt="4px !important">
                        <Text fontSize="sm" color="#6E7191" fontWeight="600">
                          All T&Cs apply
                        </Text>
                        <Box
                          sx={{ "font-size": "16px !important" }}
                          as={InfoOutlined}
                        />
                      </HStack>
                    </VStack>

                    <VStack mt="20px !important">
                      <Tag
                        size="sm"
                        // key={size}
                        variant="subtle"
                        bg="#EFF0F6"
                        p="12px 18px"
                        borderRadius="100px"
                        minW="65%"
                        w="100%"
                        justifyContent="space-between"
                      >
                        <TagLabel
                          ml="5px"
                          fontWeight="400"
                          fontSize="md"
                          textTransform="uppercase"
                          color="#6E7191"
                        >
                          {value}
                        </TagLabel>
                        <Button
                          size="xs"
                          variant="ghost"
                          aria-label="copy"
                          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                          // icon={}
                          onClick={onCopy}
                        >
                          <HStack color="var(--primary)">
                            <CopyIcon fontSize="18px" />
                            <Text
                              ml="4px !important"
                              fontSize="sm"
                              fontWeight="400"
                            >
                              Copy code
                            </Text>
                          </HStack>
                        </Button>
                      </Tag>

                      <Text fontSize="xs" color="#6E7191" fontWeight="400">
                        Or Share via
                      </Text>
                      <HStack gridGap="18px" justifyContent="center">
                        <FacebookShareButton
                          url={linkValue}
                          hashtag={"#hashtag"}
                          description={"aiueo"}
                        >
                          <VStack>
                            <FacebookReferIcon />
                            <Text color="#4E4B66" fontSize="xs">
                              Facebook
                            </Text>
                          </VStack>
                        </FacebookShareButton>

                        <TwitterShareButton
                          url={linkValue}
                          hashtag={"#hashtag"}
                          description={"aiueo"}
                        >
                          <VStack>
                            <TwitterReferIcon />
                            <Text color="#4E4B66" fontSize="xs">
                              Twitter
                            </Text>
                          </VStack>
                        </TwitterShareButton>

                        <WhatsappShareButton
                          url={linkValue}
                          hashtag={"#hashtag"}
                          description={"aiueo"}
                        >
                          <VStack>
                            <WhatsappReferIcon />
                            <Text color="#4E4B66" fontSize="xs">
                              Whatsapp
                            </Text>
                          </VStack>
                        </WhatsappShareButton>

                        <Button
                          // url={"https://peing.net/ja/"}
                          // hashtag={"#hashtag"}
                          // description={"aiueo"}
                          minH="fit-content"
                          h="fit-content"
                          minW="fit-content"
                          w="fit-content"
                          p="0"
                          bg="transparent"
                          _hover={{ bg: "transparent" }}
                          _active={{ bg: "transparent" }}
                          _focus={{ bg: "transparent" }}
                          onClick={onLinkCopy}
                        >
                          <VStack>
                            <CopyReferIcon />
                            <Text
                              color="#4E4B66"
                              fontSize="xs"
                              fontWeight="400"
                            >
                              Copy link
                            </Text>
                          </VStack>
                        </Button>
                      </HStack>
                    </VStack>

                    <Tabs w="100%" isFitted mt="48px !important">
                      <TabList
                        border="none"
                        borderRadius="6px"
                        p="6px"
                        bg="#D9DBE9"
                      >
                        <CustomTab>Registration</CustomTab>
                        <CustomTab>Trades</CustomTab>
                      </TabList>

                      <TabPanels>
                        <TabPanel px="0">
                          {(referredUsers ?? [])?.length > 4 && (
                            <HStack
                              w="100%"
                              justifyContent="flex-end"
                              py="10px"
                            >
                              <Button
                                variant="ghost"
                                bg="transparent"
                                size="sm"
                                color="#03A438"
                                minW="fit-content"
                                _focus={{
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                _hover={{ bg: "transparent" }}
                                _active={{ bg: "transparent" }}
                                onClick={() =>
                                  history.push(
                                    "/dashboard/account/refer/registrations"
                                  )
                                }
                              >
                                View more
                              </Button>
                            </HStack>
                          )}
                          <ReferrerList
                            isLoading={isLoading}
                            data={referredUsers}
                            listType="registrations"
                          />
                        </TabPanel>
                        <TabPanel px="0">
                          {(referredTrades ?? [])?.length > 4 && (
                            <HStack
                              w="100%"
                              justifyContent="flex-end"
                              py="10px"
                            >
                              <Button
                                variant="ghost"
                                bg="transparent"
                                size="sm"
                                color="#03A438"
                                minW="fit-content"
                                _focus={{
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                _hover={{ bg: "transparent" }}
                                _active={{ bg: "transparent" }}
                                onClick={() =>
                                  history.push(
                                    "/dashboard/account/refer/trades"
                                  )
                                }
                              >
                                View more
                              </Button>
                            </HStack>
                          )}
                          <ReferrerList
                            isLoading={isRefTradesLoading}
                            data={referredTrades}
                            listType="trades"
                          />
                        </TabPanel>
                      </TabPanels>
                    </Tabs>
                  </VStack>
                </Stack>
              </Container>
            </Box>

            {/* <ClaimRewardsModal isOpen={isOpen} onClose={handleClose} /> */}
          </Flex>
        </div>
      </Box>
    </Box>
  );
};

export default AccountReferral;
